import CustomerAddDialog from '@/components/customers/CustomerAddDialog.vue'
import CustomerDetailsDialog from '@/components/customers/CustomerDetailsDialog'
import CustomerEmailSelectDialog from '@/components/customers/CustomerEmailSelectDialog.vue'
import CustomerCompanySelectDialog from '@/components/customers/CustomerCompanySelectDialog.vue'

export default {
  components: {
    CustomerCompanySelectDialog,
    CustomerEmailSelectDialog,
    CustomerDetailsDialog,
    CustomerAddDialog
  },

  mixins: [],

  data() {
    return {
      customerDetailsDialogVisible: false,
      customerAddDialogVisible    : false,
      customerAddPresetData       : {},
      selectedCustomerId          : null
    }
  },

  created() {
    this.$bus.$on('show-customer-add-dialog', this.showCustomerAddDialog)
    this.$bus.$on('show-customer-details-dialog', this.showCustomerDetailsDialog)
    this.$bus.$on('hide-customer-details-dialog', this.hideCustomerDetailsDialog)
  },

  beforeDestroy() {
    this.$bus.$off('show-customer-add-dialog', this.showCustomerAddDialog)
    this.$bus.$off('show-customer-details-dialog', this.showCustomerDetailsDialog)
    this.$bus.$off('hide-customer-details-dialog', this.hideCustomerDetailsDialog)
  },

  methods: {
    showCustomerDetailsDialog(customerId) {
      this.selectedCustomerId = customerId
      if (this.customerDetailsDialogVisible) {
        this.customerDetailsDialogVisible = false
      }
      this.$nextTick(() => {
        this.customerDetailsDialogVisible = true
      })
    },

    hideCustomerDetailsDialog() {
      this.customerDetailsDialogVisible = false
    },

    showCustomerAddDialog(presetData = {}) {
      this.customerAddPresetData = presetData
      this.customerAddDialogVisible = true
    }
  }
}
